// extracted by mini-css-extract-plugin
module.exports = {"cell":"AssociatedProgramsTable_cell__-njyd"};